'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ENCODE_NAME_PREFIX = "ENCODE_NAME_PREFIX";
var FEDERATION_SUPPORTED_TYPES = [
    "script"
];

exports.ENCODE_NAME_PREFIX = ENCODE_NAME_PREFIX;
exports.FEDERATION_SUPPORTED_TYPES = FEDERATION_SUPPORTED_TYPES;
